import { render, staticRenderFns } from "./exercise.detail.vue?vue&type=template&id=1e13cde2&scoped=true&"
import script from "./exercise.detail.vue?vue&type=script&lang=js&"
export * from "./exercise.detail.vue?vue&type=script&lang=js&"
import style0 from "./exercise.detail.vue?vue&type=style&index=0&id=1e13cde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e13cde2",
  null
  
)

export default component.exports